import { useAppConfig } from 'application/configuration'
import { useCallback, useMemo } from 'react'

export const usePriceFormatter = () => {
  const {
    i18n: { locale, currencyCode }
  } = useAppConfig()

  const formatter = useMemo(
    () =>
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }),
    [currencyCode, locale]
  )

  return useCallback((value: number) => formatter.format(value), [formatter])
}
